module.exports = __webpack_public_path__ + "img/n28.53b38e8f.png";